var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2993 5.5332C16.3479 6.58219 17.062 7.91857 17.3512 9.37336C17.6404 10.8282 17.4917 12.336 16.924 13.7063C16.3563 15.0766 15.395 16.2478 14.1616 17.0718C12.9283 17.8958 11.4784 18.3356 9.99512 18.3356C8.51187 18.3356 7.06191 17.8958 5.8286 17.0718C4.59528 16.2478 3.63399 15.0766 3.06626 13.7063C2.49853 12.336 2.34986 10.8282 2.63905 9.37336C2.92824 7.91857 3.64231 6.58219 4.69095 5.5332",
    stroke: "white",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66699V10.0003",
    stroke: "white",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.067bf4a563a0808b6fb8033d98f98da1.svg";
export { ForwardRef as ReactComponent };